module.exports = __webpack_public_path__ + "MS.png?700755b456b68e7d8eebe04eb46e6ae0";